module.exports = __webpack_public_path__ + "img/option-text-color.f23f784e.svg";